var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('h3',{staticClass:"black--text font-subtitle-1 font-weight-medium"},[_vm._v(" Please Wait as we Process your Request ...... ")]),_c('Spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }